<mat-dialog-content class="error">
	<button
		mat-dialog-close
		class="o-modal-dismiss"
	>
		<epi-icon
			use="close"
			size="24"
		></epi-icon>
	</button>
	<epi-heading
		level="2"
		appears-as="1"
		color="warn"
		class="error__heading"
	>
		<epi-icon
			use="error"
			color="warn"
			size="24"
			class="error__heading-icon"
		></epi-icon>
		{{ data.heading || heading }}
	</epi-heading>
	<p
		*ngIf="subheading"
		class="error__subheading u-margin-top-small"
	>
		{{ data.subheading || subheading }}
	</p>
	<section
		*ngIf="!!messages.length"
		class="error__message u-margin-top-medium"
	>
		<p
			*ngFor="let message of messages"
			class="error__message-item u-margin-top-small"
		>
			{{ message }}
		</p>
	</section>
	<section class="error__actions u-margin-top-medium">
		<epi-button
			*ngIf="data.showRestartAction"
			mat-dialog-close
			color="secondary"
		>
			{{ data.restartText || 'Restart Quote'}}
		</epi-button>
		<epi-button
			*ngIf="data.showCloseAction"
			mat-dialog-close
			color="primary"
			button-type="ghost"
		>
			Close
		</epi-button>
	</section>
</mat-dialog-content>
